import React from 'react';
import styled from 'styled-components';

import { size } from '../../layout/helpers';

const toggleHeight = size(3);
const toggleWidth = size(6); // toggleHeight * 2
const thumbSpacing = size(0.25);
const thumbSpacingX = size(0.5); // thumbSpacing * 2
const thumbTransitionDiration = '120ms';

const toggleBorderRadius = `calc(${toggleHeight} / 2);`;

export const Wrapper = styled((props: any) => <div {...props} />).attrs(({ checked }) => ({
  role: 'checkbox',
  'aria-checked': checked,
})).withConfig({ componentId: 'sc-15an643-0' })``;

export const Toggle = styled.label.withConfig({ componentId: 'sc-15an643-1' })`
    position: relative;
    display: block;
    width: ${toggleWidth};
    height: ${toggleHeight};
    border-radius: ${toggleBorderRadius};
    background-color: var(--c-input-border);
    user-select: none;
    cursor: pointer;

    // Thumb
    &::before {
        content: "";
        position: absolute;
        left: 0;
        width: calc(${toggleHeight} - ${thumbSpacingX});
        height: calc(${toggleHeight} - ${thumbSpacingX});
        margin: ${thumbSpacing};
        border-radius: 50%;
        background-color: var(--c-bg-main);
        transition: transform ${thumbTransitionDiration} ease;
        z-index: 2;
    }

    // Active background
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: ${toggleBorderRadius};
        background-color: var(--c-input-accent-bg);
        opacity: 0;
        transition: opacity ${thumbTransitionDiration} ease;
        z-index: 1;
    }
`;

export const Checkbox = styled((props: any) => (
  <input {...props} className={`${props.checked ? 'checked' : undefined} ${props.className}`} />
)).attrs(({ checked }) => ({
  checked,
  type: 'checkbox',
})).withConfig({ componentId: 'sc-15an643-2' })`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;

    &:checked,
    &.checked {
        & ~ ${Toggle} {
            &::before {
                transform: translateX(100%) translateX(${thumbSpacingX});
            }

            &::after {
                opacity: 1;
            }
        }
    }
`;
